import React from 'react';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

function Loading({children, loading}) {
  if(loading){
    return (
      <Grid container item alignItems="center" justify="center">
        <CircularProgress />
      </Grid>
    )
  }

  return children;
}

export default Loading;
